
























































































import Vue from "vue";
import { Carousel, Slide } from "vue-carousel";

import TitleH2 from "@/components/common/TitleH2.vue";

import IconRight from "@/components/icons/IconRight.vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import IconPaginationAnimation from "@/components/icons/IconPaginationAnimation.vue";

interface IState {
  current: number;
  interval: number;
  auto: number | undefined;
  options: {
    perPage: number;
    paginationEnabled: boolean;
    loop: boolean;
    autoplay: boolean;
  };
}

export default Vue.extend({
  name: "CatalogSlider",
  components: {
    Carousel,
    Slide,
    IconRight,
    TitleH2,
    IconArrowLeft,
    IconArrowRight,
    IconPaginationAnimation,
  },
  props: {
    items: { type: Array, default: () => [] },
    title: String,
  },
  data(): IState {
    return {
      current: 0,
      interval: 5000,
      auto: undefined,
      options: {
        perPage: 3,
        paginationEnabled: false,
        loop: true,
        autoplay: false,
      },
    };
  },
  computed: {
    pagesCount(): number {
      return Math.ceil(this.items.length / this.options.perPage - 1);
    },
  },
  mounted() {
    this.resetTimer();
  },
  methods: {
    nav(n: number): void {
      this.resetTimer();
      const length: number = this.pagesCount;
      if (n < 0) {
        if (this.current === 0) {
          this.current = length;
        } else {
          this.current--;
        }
      }
      if (n > 0) {
        if (this.current === length) {
          this.current = 0;
        } else {
          this.current++;
        }
      }
    },
    pagination(index: number) {
      this.current = index;
    },
    resetTimer() {
      window.clearInterval(this.auto);
      this.auto = window.setInterval(() => {
        this.nav(1);
      }, this.interval);
    },
    stopTimer() {
      window.clearInterval(this.auto);
    },
  },
});
